

<div class="modal-footer-menu-wrap">
  @for (item of items; track item) {
    <div
      (click)="item.action()"
      class="modal-footer-menu__item"
      [class.modal-footer-menu__item--disabled]="item.isDisabled && item.isDisabled()"
      [class.modal-footer-menu__item--active]="item.isActive && item.isActive()"
      [ngbTooltip]="item.tooltip ? (item.tooltip | translate) : null">
    
      <i class="{{item.isLoading && item.isLoading() ? 'pi pi-spin pi-spinner' : item.icon}} menu-item__icon"></i>

      <span class="menu-item__text">
        {{ item.translationText | translate }}
      </span>
    </div>
  }

</div>